export default "__VITE_ASSET__db978540__"